// @flow
import React, { Fragment, useEffect, useState } from 'react';

import styles from './Partners.module.scss';
import PartnerCard from '../../components/PartnerCard/PartnerCard';
import getPartner from '../../controllers/Partner.controller';

type ICard = {
  partner_name: string;
  sections?: [
    {
      id: number;
      title: string;
      description: string[];
    }
  ];
  text?: string;
  text2?: string;
  linktext: string;
  linkadress: string;
  image: string;
  sub_title?: string;
}

const Partners = () => {
  const [partnersText, setPartnersText] = useState<ICard[] | []>([]);

  const getLanguage = () => {
    const locale = localStorage.getItem('i18nextLng');
    let languageKey;
    switch (locale) {
      case 'en':
        languageKey = 'Eng';
        break;
      case 'ru':
        languageKey = 'Rus';
        break;
      default:
        languageKey = 'Rus';
    }
    return languageKey;
  };

  const handleRes = async () => {
    const res = await getPartner(getLanguage());

    setPartnersText(res);
  };

  useEffect(() => {
    handleRes();
  }, []);

  if (!partnersText) return null;

  return (
    partnersText.length
    && (
    <>
      <div id="root" className={styles.site}>
        <div className={styles.container}>
          <div className={styles.partner}>
            <span className={styles.partners}>Postflop</span>
          </div>
          <div className={styles.grid}>
            <div />
            {partnersText.map((card) => (
              <Fragment key={card.partner_name}>
                <PartnerCard style={styles.partner_container4row} card={card} />
              </Fragment>
            ))}
            <div />
          </div>
        </div>
      </div>
    </>
    )
  );
};

export default Partners;
